import { css } from 'emotion'

export const SyncTaskCountButtonStyles = css``
